import { IconButton } from '@mui/material'
import { Moon, Sun } from 'lucide-react'
import useThemeMode from './useThemeMode'

export default function ThemeSwitcher() {
    const { isDarkMode, toggleTheme } = useThemeMode();
    return (
        <IconButton
            onClick={toggleTheme}
            sx={{
                color: isDarkMode ? '#94a3b8' : '#6b7280',
                backgroundColor: isDarkMode ? '#334155' : '#f8fafc',
                '&:hover': { backgroundColor: isDarkMode ? '#475569' : '#e2e8f0' }
            }}
        >
            {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
        </IconButton>
    )
}
